import { Form, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  useCreateInput,
  useInputById,
  useUnits,
  useUpdateInput,
} from "../../api/input";
import { setuid } from "process";

type InputModalProps = {
  open: boolean;
  selectedId: string;
  hideModal: () => void;
};

const InputModal: React.FC<InputModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const { TextArea } = Input;
  const [categories, setCategories] = useState<string[]>([]);
  const [messuringUnits, setMessuringUnits] = useState<string[]>([]);

  const { data: unitsData } = useUnits();
  const { mutateAsync: createInput, isPending: creating } = useCreateInput();
  const {
    mutateAsync: updateInput,
    isSuccess,
    isPending: updating,
  } = useUpdateInput();

  const { data: input, refetch } = useInputById(selectedId);
  const [category, setCategory] = useState<string>(input?.data?.category || "");
  const [name, setName] = useState<string>(input?.data?.data?.name || "");
  const [unit, setUnit] = useState<string>(
    input?.data?.data?.measurementUnit || "",
  );
  const [description, setDescription] = useState<string>(
    input?.data?.data?.description || "",
  );

  useEffect(() => {
    if (selectedId) {
      refetch();
    }
  }, [selectedId]);

  useEffect(() => {
    if (unitsData?.data) {
      setMessuringUnits(unitsData.data.map((x) => x));
    }
  }, [unitsData]);

  useEffect(() => {
    if (input && input.data && input.data.data) {
      setCategory(input.data.data.category);
      setName(input.data.data.name);
      setUnit(input.data.data.measurementUnit);
      setDescription(input.data.data.description);
    }
  }, [input]);

  const onsubmit = async () => {
    if (category && name && unit) {
      if (selectedId) {
        try {
          const result = await updateInput({
            id: Number(selectedId),
            input: {
              category,
              name,
              measurementUnit: unit,
              description,
            },
          });

          if (result && result.id) {
            message.success("Input updated successfully");
          }
        } catch (err: any) {
          message.error("Operation failed");
        }
      } else {
        try {
          const result = await createInput({
            category,
            name,
            measurementUnit: unit,
            description,
          });

          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.id
          ) {
            message.success("Input created successfully");
          }
        } catch (err: any) {
          message.error("Operation failed");
        }
      }
    }
    hideModal();
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId ? "Edit input" : "Create new "}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      onCancel={hideModal}
      closable
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Select
          value={category}
          placeholder="Select category"
          style={{ width: "100%" }}
          onChange={(val: any) => setCategory(val)}
          options={["CHEMICALS", "FERTILIZERS", "SEEDS", "TRANSPORT"].map(
            (category: string) => {
              return { label: category, value: category };
            },
          )}
        />
        <Input
          placeholder="Insert name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Select
          value={unit}
          placeholder="Select unit"
          style={{ width: "100%" }}
          onChange={(val: any) => setUnit(val)}
          options={messuringUnits.map((u: string) => {
            return { label: u, value: u };
          })}
        />
        <TextArea
          rows={4}
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default InputModal;
